import React from "react";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";

class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
    };
  }

  render() {
    return (
      <div id="detailSide" /*className="d-none"*/>
        <div className="detail-title">Verplichtingen in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/management-maintenance/obligations/");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Verplichtingen
            </a>
          </div>
          <div className="float-right mt-0">
            <a
              id="edit-button"
              className="button bewerken"
              onClick={() => {
                this.props.history.push(
                  "/management-maintenance/obligations/edit/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
            >
              Bewerken
            </a>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Code</div>
              <div className="box-title-2-active">
                {this.state.rowData.algemeenCodeBase}
              </div>
              <span className="tooltiptext detail">
                {this.state.rowData.algemeenCodeBase}
              </span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Omschrijving</div>
              <div className="box-title-2">
                {this.state.rowData.omschrijving}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Budget</div>
              <div className="box-title-2">{this.state.rowData.budget}</div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Werkplan</div>
              <div className="box-title-2">{this.state.rowData.werkplan}</div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Boekingsnummer</div>
              <div className="box-title-2">
                {this.state.rowData.boekingsnummer}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Datum aanvang</div>
              <div className="box-title-2">
                {this.state.rowData.datumaanvang}
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Datum oplevering</div>
              <div className="box-title-2">
                {this.state.rowData.datumoplevering}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Organisatie</div>
              <div className="box-title-2">
                {this.state.rowData.organisatie}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Opdrachtgever</div>
              <div className="box-title-2">
                {this.state.rowData.opdrachtgever}
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Directievoeder</div>
              <div className="box-title-2">
                {this.state.rowData.directievoeder}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Toezichthouder</div>
              <div className="box-title-2">
                {this.state.rowData.toezichthouder}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Eenheid</div>
              <div className="box-title-2">{this.state.rowData.eenheid}</div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Eenheidsprijs (€)</div>
              <div className="box-title-2">
                {this.state.rowData.eenheidsprijs}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Totaal (€)</div>
              <div className="box-title-2">{this.state.rowData.totaal}</div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Kosten per jaar (€)</div>
              <div className="box-title-2">
                {this.state.rowData.kostenPerJaar}
              </div>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Opmerking</div>
              <div className="box-title-2">{this.state.rowData.opmerking}</div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Akkoord</div>
              <div className="box-title-2">{this.state.rowData.eenheid}</div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box--title-1">Akkoord</div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={this.state.rowData.akkoord ? true : false}
                  disabled
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Status</div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={this.state.rowData.isActive ? true : false}
                  disabled
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        {/* <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam Beheereenheid</div>
              <div className="box-title-2-active" id="algemeenNaam">
                {this.state.rowData.algemeenNaam}
              </div>
              <span className="tooltiptext detail" id="algemeenNaam-tooltip">
                {this.state.rowData.algemeenNaam}
              </span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code Beheereenheid</div>
              <div className="box-title-2" id="algemeenCode">
                {this.state.rowData.algemeenCode}
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  checked={this.state.rowData.isActive ? true : false}
                  disabled
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-sm-6">
            <div className="inp-labl">Start horizon</div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="text"
                className="form-control inp-h inpp"
                id="startDate"
                disabled
                placeholder={this.state.rowData.startDate}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="inp-labl">Eind horizon</div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="text"
                className="form-control inp-h inpp"
                id="endDate"
                disabled
                placeholder={this.state.rowData.endDate}
              />
            </div>
          </div>
        </div>
      */}
      </div>
    );
  }
}

export default Detail;
